import { render } from "./vh-doughnut-chart.vue?vue&type=template&id=6f3349ef"
import script from "./vh-doughnut-chart.vue?vue&type=script&lang=js"
export * from "./vh-doughnut-chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__